import { useContext } from 'react';

import { StoreContext } from '../store';

export default function useSelectedMessageThreadId() {
  const { state } = useContext(StoreContext);

  return state.selectedMessageThreadId;
}
